export default "__VITE_ASSET__awJ2Oe4R__";